compiler('#import_source', (element) => {
    const helpCenterLink = document.getElementById('help-center-link');
    const helpCenterLinks = JSON.parse(element.getAttribute('data-help-center-links'));
    const helpCenterLinkHtmlTemplate = element.getAttribute('data-help-center-link-html');

    function setHelpCenterLink(selectedValue) {
        if (helpCenterLinks[selectedValue]) {
            const helpCenterUrl = helpCenterLinks[selectedValue];
            const linkHtml = helpCenterLinkHtmlTemplate.replace('%{link}', helpCenterUrl);
            helpCenterLink.innerHTML = linkHtml;
        } else {
            helpCenterLink.innerHTML = '';
        }
    }

    element.addEventListener('change', function() {
        const selectedValue = this.value;
        setHelpCenterLink(selectedValue);
    });

    const selectedValue = element.value;
    setHelpCenterLink(selectedValue);
});
